import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  gs,
  ls,
  f,
  cmFTH,
  BoxC,
  BtnC,
  BtnTopC,
  IptC,
  LblC,
  TblC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnTopC from "./_ccmBtnTopC";
import * as TblC from "./_ccmTblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as ica from 'src/ica';

import * as icvI18___Mz from './icvI18___Mz';

let $i18rs = [] as ht.ls;

const $schz = {
//  _31r_fst: -1,
  word: '',
}
const $sch = (frcUdt: () => void) => {
  icvI18___Mz.loadI18rLsAsync({
    word: $schz.word,
  })
  .then((_ls: ht.ls) => {
    $i18rs = _ls
    frcUdt();
  })
};

export const S = (pz: {
  sPz: ht.dz,
}) => {

//  const _udtThis  = ls.udtThis();

/*
  React.useEffect(() => {
    cmFTH.loadAllAsync({
      frcUdt: _udtThis,
      bfrAsync: () => [
        _cv_31___Mz.load_31rLsAsync()
        .then((_ls: ht.ls) => {
          $_31rs = _ls.concat([{ key: -1, pfx: 'すべて' }]);
        }),
      ]
    })
  }, []);
*/

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a(`fd/rsc`),
      oClds: [
/*
        cr.c(LblC.N, {
          key: -10,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/20'),
          lblCz: {
            boxStlz: a('dw/5'),
            textz: {
              pfx: '施設',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'pcr',
                  ls: $_31rs,
                  vle: $schz._31r_fst ?? -1,
                  onChg: (_dz: ht.dz) => {
                    $schz._31r_fst = _dz.key;
                  }
                },
              })
            ]
          },
        }),
*/
        cr.c(LblC.N, {
          key: -20,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/27'),
          lblCz: {
            boxStlz: a('dw/12'),
            textz: {
              pfx: '団体番号・名',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'text',
                  vle: $schz.word,
                  onChg: (_s: ht.s) => {
                    $schz.word = _s;
                  },
                },
              })
            ]
          },
        }),
        cr.c(BtnC.N, {
          key: -30,
          abtType: 'schCmnz',
          lblCz: {
          },
          bfrIconCz: {
          },
          pslPtyz: {
            onPress: () => $sch(pz.sPz.udtAll),
          }
        })
      ]
    })
  );
};

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        onPrsBack: () => {
          cr.moveTo({
            pageName: 'icvHomeS10Rz',
          });
        }
      }
    })
  )
};

/*
export const F = (pz: {
  sPz: ht.dz,
}) => {
  return (
    cr.c(GridC.N, {
      key: -10,
      abtType: 'barBtnFtnCmnz',
      boxStlz: a('dw/120 mb/2'),
      lineCs: [
        {
          cellCs: [
            {
              oClds: [
              ]
            },
            {
              oClds: [
                cr.c(BtnC.N, {
                  key: -10,
                  abtType: 'ctdFtnStfz',
                  boxStlz: a('dw/25 mr/1'),
                  lblCz: {
                    textz: {
                      pfx: '団体一覧(EXCEL)',
                    }
                  },
                  pslPtyz: {
                    onPress: () => {
                      icvI18___Ez.eptExlAsync({
                        i18rs: $i18rs,
                      });
                    }
                  }
                })
              ]
            },
            {
              oClds: [
              ]
            },
          ]
        }
      ]
    })
  );
}
*/

export const L = (pz: ht.viewListCz) => {

  const _gUserz = gs.useUserz();
  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    if (_gUserz.crt._dmn > 0) {
      $sch(_udtThis);
    }
  }, [
    _gUserz.crt._dmn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '団体番号',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '団体名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
//  $i17rLs.map( ( _i18rz: ht.dz ) => {
  $i18rs.map( ( _i18rz: ht.dz ) => {
    const _cellCs = [
      {
        boxStlz: a('f/0.3'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _i18rz.i18rab100s,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _i18rz._pfx,
              ptyz: a(`tn/1`),
            }
          })
        ]
      },
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {
            },
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  i18r_fst: _i18rz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};
